// Polyfills

import 'babel-polyfill';
import 'zone.js/dist/zone';

if (!APP_PRODUCTION) {
  require('zone.js/dist/long-stack-trace-zone'); // eslint-disable-line global-require

  Error.stackTraceLimit = Infinity;
}



// WEBPACK FOOTER //
// ./src/client/polyfills.js